import { App, createApp, DefineComponent, ref } from 'vue';
import ModalAsideComponent from '@use/useModalAside/ModalAsideComponent.vue';
import { showBodyScroll, hideBodyScroll } from '@/utils/helpers';

import { storePinia } from '@/storePinia';

let app: App | null;

const { body } = document;

body.insertAdjacentHTML('beforeend', '<div class="modal-aside-component"></div>');
// body.insertAdjacentHTML('beforeend', '<div id="modals"></div>');
const isOpen = ref(true);
interface IProps {
  [name: string]: any;
}

interface IOptions {
  width?: string;
  backgroundClose?: boolean;
  afterLeave?: () => void;
  afterRemove?: () => void;
  empty?: boolean;
}
let callBack: (() => void) | undefined;

export default function useModalAside() {
  const hide = (): Promise<void> => {
    if (!app) {
      return new Promise((resolve) => {
        resolve();
      });
    }

    isOpen.value = false;

    return new Promise((resolve) => {
      callBack = resolve;
    });
  };
  const show = async (AppComponent: DefineComponent, props?: IProps, options?: IOptions) => {
    try {
      if (isOpen.value) {
        await hide();
      }

      isOpen.value = true;

      app = createApp(
        <ModalAsideComponent>
          <AppComponent {...props} />
        </ModalAsideComponent>,
        {
          isOpen,
          options,
          afterLeave: () => {
            app?.unmount();

            app = null;
            if (typeof options?.afterLeave === 'function') {
              options.afterLeave();
            }
            showBodyScroll();
          },
          afterRemove() {
            callBack?.();
            if (typeof options?.afterRemove === 'function') {
              options.afterRemove();
            }
          },
        }
      );

      app.use(storePinia);

      hideBodyScroll();
      app.mount('.modal-aside-component');
    } catch (err) {
      console.error(err);
    }
  };

  return {
    show,
    hide,
  };
}
